import * as Request from '../../../request'
import * as Constants from './constants'

// TODO: Clean up handling of templatename and identifier.
export const toggleModalHeader = () => ({type: Constants.TOGGLE_PREVIEW_NEWSBRIEF})
export const toggleModal = (templateName: string, communityIdentifier: string, contentPayload: {} = null) =>
  ({ type: Constants.TOGGLE_PREVIEW_NEWSBRIEF, templateName, communityIdentifier, contentPayload})

export const getEmailTemplate = (templateName: string, communityIdentifier: string, contentPayload: {} = null) =>
  Request.requestActionCreator(Constants.FETCH_PREVIEW)({
    method: 'POST',
    payload: {
      community_identifier: communityIdentifier || 'rasa',
      content: contentPayload,
      email_template: templateName,
    },
    url: '/newsbrief/preview',
})



// WEBPACK FOOTER //
// ./src/pages/newsbrief/preview-newsbrief/actions.ts